import { computed } from 'vue'
import { useFeatureFlags } from '@/Hooks/Company/useFeatureFlags.js'

export function usePhotographerBrandingName() {
  const { hasFeatureFlag } = useFeatureFlags()

  const photographerBrandingName = computed(() => {
    if (hasFeatureFlag('zillow_integrations_rebrand')) {
      return 'Zillow Media Advantage'
    }
    if (hasFeatureFlag('hd_photos_rebrand')) {
      return 'Photographer Branding & Enhanced Media'
    }
    return 'Photographer Branding and HD Photos'
  })

  return { photographerBrandingName }
}
